<template>
  <div class="content">
    <!-- <header v-if="isWX != 0">
      <i class="iconfont icon-home_location_icon_l" @click="returnBack"></i>
      <p>手续费费用说明</p>
    </header> -->
    <h5-header v-if="isWX != 0" :header-msg="headerMsg"></h5-header>
    <div class="mt">
        <frameset>
            <frame src="https://api.yamyamyam.com/mobile/payText.html" name="view_frame" scrolling="auto">
        </frameset> 
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        isWX:'1',
        headerMsg: {
          title: "手续费费用说明",
          url: "/joinup",
        }
    };
  },
  mounted() {
    //   this.rule()
     this.isWX = this.GetQueryString("wx")
  },
  
  methods: {
    // rule(){
    //     console.log('1')
    //     window.open('','_parent')
    // },
    // returnBack(){
    //   this.$router.push({
    //     path: "/joinup",
    //     query: {
    //       type: this.GetQueryString("type"),
    //       refereeId: this.GetQueryString("refereeId"),
    //       wx:this.GetQueryString("wx") || '1',
    //     }
    //   }); //跳转
    // }
  }
};
</script>

<style lang="scss" scoped>
.content {
    height: 667px;
    overflow: hidden;
  header {
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    z-index: 2013;
    width: 100%;
    height: 44px;
    background: #fff;
    z-index: 9999;
    i {
      font-size: 26px;
    }
    p {
      font-size: 18px;
      margin-left: 104px;
    }
  }
  // .cont{
  //     height: fit-content;
  //     margin-top: 0;
  // }
  .mt{
      height: fit-content;
      margin-top: 0
  }
}
</style>
